export default "__VITE_ASSET__CmoPgFMU__"